import { useEffect, useState } from 'react'
import { getAppVersion } from '~/utils/common'

export const useAppVersion = () => {
  const [appVersion, setAppVersion] = useState<string>('?.?.?')

  const doGetAppVersion = async () => {
    setAppVersion(await getAppVersion())
  }

  useEffect(() => {
    void doGetAppVersion()
  }, [])

  return appVersion
}
